import axios from 'axios'
import { PartnerRegistered } from '../../interfaces'

export const updatePartner = (partnerData: PartnerRegistered) => {
  return axios
    .put('/data/sadarbības_partneris/' + partnerData.id, partnerData)
    .then((resp) => resp.data)
}
